import type { Pagination, PaginationRequest } from '../models';

export default {
  getTotalPages(pagination: PaginationRequest) {
    return pagination ? Math.ceil(+pagination.total / +pagination.size) : 0;
  },

  /**
   * Genereate Pagination Summary
   *
   * @param {obj} pagination
   * @param {number} totalItems
   */
  getPaginationSummary(pagination: Pagination, totalItems: number) {
    // console.log('getPaginationSummary', { pagination, totalItems });
    const { page } = pagination;
    const start = totalItems > 0 ? (page - 1) * pagination.rowsPerPage + 1 : 0;
    let end = totalItems;

    if (pagination.rowsPerPage < totalItems) {
      end = pagination.rowsPerPage * page;
      if (end > totalItems) {
        end = totalItems;
      }
    }
    const summary = {
      rowsPerPage: pagination.rowsPerPage,
      from: start,
      to: end,
      total: totalItems,
    };
    return summary;
  },

  /**
   * Get the current page
   *
   * @param {obj} pagination
   * @param {number} totalItems
   */
  getCurrentPage(pagination: Pagination, totalItems: number) {
    let page = 1;
    page =
      totalItems <= pagination.rowsPerPage
        ? 1
        : totalItems / pagination.rowsPerPage <= pagination.page - 1
        ? pagination.page - 1
        : pagination.page;
    return page;
  },

  getInitialPagination() {
    const initialPagination = {
      sortBy: 'createdDate',
      descending: true,
      rowsPerPage: 100,
      page: 1,
      totalItems: 0,
      pages: 1,
    };
    return initialPagination;
  },
};
